import { useActiveIncentives, UserV1 } from '@tovala/browser-apis-combinedapi'
import { events, getSourceIDFromPathname } from 'analytics/events'
import Modal, { ModalHeader, ModalPanel } from 'components/common/Modal'
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { track } from 'utils/analytics'
import AccountBalance from './account/AccountBalance'
import AccountIncentives from './account/AccountIncentives'

const PromosCreditsModal = ({
  onCloseModal,
  user,
}: {
  onCloseModal: () => void
  user: UserV1
}) => {
  const { pathname } = useLocation()
  useEffect(() => {
    track(events.OPENS_PROMOS_AND_CREDITS, {
      source_id: getSourceIDFromPathname(pathname),
    })
  }, [pathname])

  const { data: activeIncentives = [] } = useActiveIncentives({
    userID: user.id,
  })
  return (
    <Modal onCloseModal={onCloseModal}>
      <ModalPanel panelColor="grey">
        <div className="w-[666px] sm:w-full">
          <ModalHeader onClickClose={onCloseModal}>
            <span className="block text-base uppercase">
              Redeem Gift Card/Promo
            </span>
          </ModalHeader>
          <div className="p-6 sm:p-4">
            <AccountBalance user={user} />
            <AccountIncentives
              activeIncentives={activeIncentives}
              isFreeDessertCustomer={user.isFreeDessertCustomer}
            />
          </div>
        </div>
      </ModalPanel>
    </Modal>
  )
}

export default PromosCreditsModal
